import { useEffect, useState } from "react";

import ARROWRIGHT from "../../../assets/images/Modal/Line 15.png";
import ARROWLEFT from "../../../assets/images/Modal/Line 14.png";
import RING from "../../../assets/images/Modal/RING.png";

import "../../../../pages/style/ModelGeneralPage/PhotoModal.css";
import "../../ButtonLeftRight/styles/buttonleftright.css";

import { IPhotoModal } from "../../../interfaces";

export const PhotoModalSecond = (params: IPhotoModal) => {
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    setCounter(0);
  }, [params.active]);

  const OnCountChange = (sign: string) => {
    if (sign === "+") {
      if (counter === params.content.length - 1) {
        setCounter(0);
      } else {
        setCounter(counter + 1);
      }
    } else {
      if (counter === 0) {
        setCounter(params.content.length - 1);
      } else {
        setCounter(counter - 1);
      }
    }
  };

  //перелистывание изображений клавишами
  onkeydown = (event) => {
    if (event.key === "ArrowRight" && params.active === true) {
      OnCountChange("+");
    } else if (event.key === "ArrowLeft" && params.active === true) {
      OnCountChange("-");
    }
  };
  return (
    <div
      className={params.active ? "ph_modal_main" : "ph_modal_main_hidden"}
      onClick={(e) => {
        e.stopPropagation();
        params.setActive(false);
      }}
    >
      <div
        className="ph_modal_content_second"
        onClick={(e) => e.stopPropagation()}
        style={{ minWidth: "35vw" }}
      >
        {/*Стрелка влево, если нужна*/}
        {params.content?.length > 1 ? (
          <div className="ArrowBlockAllL ArrowBlockAll">
            <div className="ArrowBlockAll_NotCenter"></div>
            <div
              className="ArrowBlockAll_Center"
              onClick={() => OnCountChange("+")}
            >
              <img
                src={ARROWLEFT}
                className="ArrowBlockAll_Center_img"
                alt=""
              />
            </div>
            <div className="ArrowBlockAll_NotCenter"></div>
          </div>
        ) : null}
        {/*Стрелка влево, если нужна*/}

        {/*Контент*/}
        {params.list ? (
          <div
            className="ph_modal_adaptive"
            style={{
              backgroundColor: "white",
              zIndex: 5,
              justifyContent: "center",
            }}
          >
            <h3
              className="ph_modal_title_main"
              style={{ paddingBottom: "1rem" }}
            >
              {params.title}
            </h3>
            {params.list?.map((e, i) => {
              return (
                <div key={i} style={{ width: "100%" }}>
                  <p className="ph_modal_title" style={{ fontWeight: 100 }}>
                    {e.title}
                  </p>
                  <ul
                    style={{ position: "relative", listStyle: "none" }}
                    className="ModalPhoto"
                  >
                    {e.quotes.map((e, i) => {
                      if (e.substring(0, 1) === "_") {
                        return <h2 key={i}>{e.substring(1, e.length)}</h2>;
                      } else {
                        return (
                          <li key={i} className="ph_modal_li">
                            {e}
                          </li>
                        );
                      }
                    })}
                  </ul>
                </div>
              );
            })}
          </div>
        ) : (
          <div
            style={{
              zIndex: 5,
              backgroundColor: "white",
              textAlign: "center",
              width: "-webkit-fill-available",
              display: "flex",
              flexDirection: "column",
              margin: "-2px",
            }}
          >
            <div className="ph_modal_adaptive">
              <p className="ph_modal_title">{params.title}</p>
              <div className="ph_modal_image_block" style={{ flex: 1 }}>
                <img
                  className="ph_modal_image"
                  src={params.content ? params.content[counter] : ""}
                  alt=""
                  style={{
                    minWidth: "0vh",
                    maxHeight: "23vw",
                    maxWidth: "40vw",
                    padding: "0",
                  }}
                />
                {params.damage ? (
                  params.damage[counter].map((e, i) => {
                    return (
                      <img
                        className="ph_modal_ring"
                        key={i}
                        src={RING}
                        style={{
                          height: `${e.height}%`,
                          width: `${e.width}%`,
                          left: `${e.posX}%`,
                          top: `${e.posY}%`,
                        }}
                        alt=""
                      />
                    );
                  })
                ) : (
                  <></>
                )}
              </div>

              {params.text && params.text[0] !== "" ? (
                <p className="text_format_Photo">
                  {params.text[1] !== undefined
                    ? counter === 0
                      ? params.text[0]
                      : params.text[1]
                    : params.text[0]}
                </p>
              ) : null}
            </div>
          </div>
        )}

        {/*Контент*/}

        {/*Стрелка вправо, если нужна*/}

        {params.content && params.content.length > 1 ? (
          <div className="ArrowBlockAllR ArrowBlockAll">
            <div className="ArrowBlockAll_NotCenter"></div>
            <div
              className="ArrowBlockAll_Center_Right"
              onClick={() => OnCountChange("-")}
            >
              <img
                src={ARROWRIGHT}
                className="ArrowBlockAll_Center_img"
                alt=""
              />
            </div>
            <div className="ArrowBlockAll_NotCenter"></div>
          </div>
        ) : null}
        {/*Стрелка вправо, если нужна*/}
      </div>
    </div>
  );
};
